module.exports = __webpack_public_path__ + "static/media/gallery-10.d34a8748.jpeg";